import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Dispatch, ReactNode, SetStateAction } from 'react';

interface Props {
    children: ReactNode,
    setShowModal: Dispatch<SetStateAction<boolean>>;
    largeWidht?: boolean;
}

export function ChangeDealStageFormContainer({ children, setShowModal, largeWidht }: Props) {

    return (
        <div className={`bg-white ${largeWidht == true ? "w-[1000px] ": "w-[650px] "} max-w-[1000px] rounded max-h-screen  overflow-auto`}>
            <div className="flex justify-end bg-gray-100 rounded">
                <button onClick={() => setShowModal(false)}>
                    <CloseRoundedIcon  />
                </button>
            </div>

            {children}

        </div>
    );
}